import { render, staticRenderFns } from "./NewDocumentsProcessor.vue?vue&type=template&id=1ec161b2&"
import script from "./NewDocumentsProcessor.vue?vue&type=script&lang=ts&"
export * from "./NewDocumentsProcessor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports